var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttemptedtestprofile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 10.5L12.8831 12.9436C13.3016 13.2574 13.8912 13.1957 14.2357 12.8021L20.625 5.5",
    stroke: "#07BD81",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.625 12.5C21.625 14.3805 21.036 16.2137 19.9406 17.7423C18.8453 19.2709 17.2986 20.4179 15.518 21.0224C13.7373 21.6268 11.812 21.6583 10.0124 21.1125C8.21292 20.5666 6.62959 19.4707 5.48482 17.9789C4.34005 16.487 3.69135 14.674 3.62982 12.7945C3.56829 10.915 4.09703 9.06344 5.14177 7.49987C6.18652 5.9363 7.69479 4.73925 9.45475 4.07685C11.2147 3.41444 13.138 3.31996 14.9544 3.80667",
    stroke: "#07BD81",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttemptedtestprofile);
export default __webpack_public_path__ + "static/media/attempted testprofile.175f812aa5653266d9a40d82bf6a242c.svg";
export { ForwardRef as ReactComponent };